












import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import App from '@kasasa/fbase-components/src/services/Auth/types/App';
import AccountDetails from '@/components/AccountDetails.vue';
import SavingsHistoryDataTable from '@/components/SavingsHistoryDataTable.vue';

@Component({
  components: { SavingsHistoryDataTable, AccountDetails },
})
export default class SaverbotAccountView extends Vue {
  @State('portalHeaderData') statePortalHeaderData!: any;

  @State('profile') stateProfile!: any;

  @Action('getProfile') actionGetProfile!: any;

  @Action('getSaverbotAccount') actionGetSaverbotAccount!: any;

  @Action('getSavingsHistory') actionGetSavingsHistory!: any;

  @Watch('statePortalHeaderData')
  onPortalHeaderDataChange() {
    this.profileAdminApp = this.statePortalHeaderData.appManager.find((app: any) => app.slug === 'kcas-profile-admin') as App;
  }

  loadingAccount: boolean = false;

  loadingHistory: boolean = false;

  profileAdminApp: App = {} as App;

  get computedBreadcrumbItems(): any[] {
    return [
      {
        text: 'Find Profile',
        disabled: false,
        href: `${this.profileAdminApp.url}`,
      },
      {
        text: this.stateProfile ? this.stateProfile.preferredUsername : 'User',
        disabled: !this.stateProfile,
        href: this.profileAdminLink,
      },
      {
        text: 'SaverBot Console',
        disabled: true,
      },
    ];
  }

  get profileAdminLink() {
    if (this.stateProfile) {
      return `${this.profileAdminApp.url}/#/detail/${this.stateProfile.id}`;
    }

    return '';
  }

  async getProfile() {
    const { externalId } = this.$route.params;
    this.actionGetProfile(externalId);
  }

  async getSaverbotAccount() {
    this.loadingAccount = true;
    const { externalId } = this.$route.params;
    await this.actionGetSaverbotAccount(externalId);
    this.loadingAccount = false;
  }

  async getSavingsHistory() {
    this.loadingHistory = true;
    const { externalId } = this.$route.params;
    await this.actionGetSavingsHistory(externalId);
    this.loadingHistory = false;
  }

  resetState() {
    this.loadingAccount = false;
    this.loadingHistory = false;
  }

  mounted() {
    this.resetState();
    this.getSaverbotAccount();
    this.getSavingsHistory();
    this.getProfile();
  }
}
